import { useScanDeviceApiDetailQuery } from '@hooks/api';
import type { ScanDeviceDetail } from 'types/api';

export const useScanDevice = useScanDeviceApiDetailQuery<ScanDeviceDetail>('/devices');
